var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRisks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, ">\n    ", _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--app-icons-color)",
    strokeWidth: "3px",
    d: "M2.09,18.38l8.16-14.7a2,2,0,0,1,3.5,0l8.16,14.7a2,2,0,0,1-1.75,3H3.84A2,2,0,0,1,2.09,18.38Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff933c",
    d: "M10.89,15.58l-.52-5.73v-.1a.5.5,0,0,1,.5-.5h2.62a.5.5,0,0,1,.5.5v.1l-.53,5.73A.48.48,0,0,1,13,16H11.36A.48.48,0,0,1,10.89,15.58Zm-.08,2.7V17.06a.38.38,0,0,1,.38-.38h2a.38.38,0,0,1,.38.38v1.22a.38.38,0,0,1-.38.38h-2A.38.38,0,0,1,10.81,18.28Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRisks);
export default __webpack_public_path__ + "static/media/risks.ff7b6c2f.svg";
export { ForwardRef as ReactComponent };